import addressApi from '@/api/pumba/addressApi';

export const state = {
    address: null,
};

export const getters = {
    getAddress: (states) => states.address,
};

export const mutations = {
    ['UPDATE_ADDRESS'](states, address) {
        states.address = address;
    },
};

export const actions = {
    async loadAddress({ commit }) {
        const { data: address } = await addressApi.fetchAddress();

        commit('UPDATE_ADDRESS', address.data[0]);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
